<template>
  <div
    v-if="survey.surveyQuestions?.length > 0"
    class="survey-card"
    :class="{ zIndex: surveyFocus }"
  >
    <SurveyStart v-if="showSurvey" :survey="survey"></SurveyStart>
    <SurveyVerification
      showResultText
      v-if="showSurveyVerification"
    ></SurveyVerification>
    <SurveyResult
      :surveyResult="surveyResult"
      v-if="showSurveyResults"
    ></SurveyResult>
  </div>
</template>

<script>
import SurveyStart from "@/components/Survey/SurveyStart";
import SurveyResult from "@/components/Survey/SurveyResult";
import SurveyVerification from "@/components/Survey/SurveyVerification";

export default {
  name: "SurveyCard",
  props: {
    showSurvey: {
      type: Boolean,
      default: false,
    },
    showSurveyVerification: {
      type: Boolean,
      default: false,
    },
    showSurveyResults: {
      type: Boolean,
      default: false,
    },
    surveyFocus: {
      type: Boolean,
      default: false,
    },
    surveyResult: {
      type: Object,
      default: () => {},
    },
    survey: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    SurveyResult,
    SurveyVerification,
    SurveyStart,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";
.survey-card {
  max-width: 326px;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
}
@media screen and (max-width: 767px) {
  .survey-card {
    max-width: 100%;
  }
}
</style>
